module.exports = __webpack_public_path__ + "img/vimeo.db052af7.png";